import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";

export default function InformationDialog({
  open,
  onClose,
  title,
  message,
}) {
  let msgList = [];
  if (message) {
    msgList = message.split('\n')
  }
  return (
    <Dialog
      open={open}
      role="alertdialog"
      maxWidth={false}
      aria-labelledby="info-dialog-title"
      aria-describedby="info-dialog-description"
      sx={{ zIndex: 2000 }}>
      <DialogTitle id="info-dialog-title" sx={{ textAlign: "center", fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent id="info-dialog-description" tabIndex={-1}>
        {msgList?.length === 1 && (
          <DialogContentText sx={{ whiteSpace: "pre-line", color: "text.primary", fontSize: "1rem" }}>
            {msgList[0]}
          </DialogContentText>
        )}
        {msgList?.length > 1 && (
          <DialogContentText component="div" sx={{ color: "text.primary", fontSize: "1rem" }}>
            <ul style={{ margin: 0, paddingLeft: 20 }}>
              {msgList.map((line, index) => (
                <li key={index}>{line}</li>
              ))}
            </ul>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" sx={{ fontWeight: 700 }}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
